import { render, staticRenderFns } from "./r-reward-generator-config-dialog.vue?vue&type=template&id=ba94e036"
import script from "./r-reward-generator-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-reward-generator-config-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba94e036')) {
      api.createRecord('ba94e036', component.options)
    } else {
      api.reload('ba94e036', component.options)
    }
    module.hot.accept("./r-reward-generator-config-dialog.vue?vue&type=template&id=ba94e036", function () {
      api.rerender('ba94e036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-generator/r-reward-generator-config-dialog.vue"
export default component.exports